export class AnnexModel {
    patientCode = '';
    postionX = 0;
    postionY = 0;
    type = '';
    indexPic = '';
    notes = '';
    userID = 'sa';
    compCode = '1';
    modifaiedDate = '2021-01-01';
}
